import React, { useState, useContext } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  withStyles,
  Card,
  CardContent,
  CardActions,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import StepActions from "./stepActions";
import styles from "./styles";

const RequestTypeStep = (props) => {
  const {
    request,
    requestTypes = [],
    documentRequests = [],
    canSkip,
    onCancel,
    onNext,
  } = props;
  const { t } = useTranslation();
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const [requestType, setRequestType] = useState(request.requestType || null);
  const [requestTypeError, setRequestTypeError] = useState("");

  const { showConfirmation } = useContext(ModalDialogContext);

  const handleChange = (event) => {
    setRequestTypeError("");
    setRequestType(event.target.value);
  };

  const handleNext = (event) => {
    if (!requestType) {
      setRequestTypeError(t("Please select a request type"));
      return;
    }
    const gr = documentRequests.find(
      (dr) => dr.request_type === "1" && dr.status !== "complete",
    );
    if (requestType === "1" && gr) {
      showConfirmation({
        message: t("messages.record.documentRequest.genericTypeExists"),
        onPressYes: async (event) => {
          onNext(true, { requestType });
        },
      });
    } else {
      onNext(true, { requestType });
    }
  };

  const handleCancel = (event) => {
    onCancel();
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Grid container spacing={1}>
          <Grid item>
            <Typography>
              {t("labels.record.documentRequest.steps.requestTypeStep.header")}
            </Typography>
          </Grid>
          <Grid container>
            <RadioGroup
              aria-label="RequestType"
              name="requestType"
              value={requestType}
              onChange={handleChange}
              row
            >
              {requestTypes.map((rt) => (
                <React.Fragment key={rt.value}>
                  <Grid item xs={12}>
                    <FormControlLabel
                      value={rt.value}
                      control={<Radio color="primary" />}
                      label={rt.label}
                      labelPlacement="end"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={classes.helpText}>
                      {rt.helpText}
                    </Typography>
                  </Grid>
                </React.Fragment>
              ))}
            </RadioGroup>
          </Grid>
          <Grid item>
            <div className={classes.errorText}>{requestTypeError}</div>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions disableSpacing>
        <StepActions
          canBack={false}
          canSkip={canSkip}
          onCancel={handleCancel}
          onNext={handleNext}
        />
      </CardActions>
    </Card>
  );
};

export default withStyles(styles, { withTheme: true })(RequestTypeStep);
